module.exports = __webpack_public_path__ + "fonts/SFProDisplay-Bold.23afe2aa.woff";